let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4oVpa")).then(() => parcelRequire('dn2cU'));